import { z } from "zod";

export const StageRoleSchema = z.object({
    isManager: z.boolean().default(false),
    isOwner: z.boolean().default(false),
    isTender: z.boolean().default(false),
});

export type StageRole = z.infer<typeof StageRoleSchema>;